import { render, staticRenderFns } from "./SiteForm.vue?vue&type=template&id=f2a266b8&scoped=true"
import script from "./SiteForm.vue?vue&type=script&lang=js"
export * from "./SiteForm.vue?vue&type=script&lang=js"
import style0 from "./SiteForm.vue?vue&type=style&index=0&id=f2a266b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a266b8",
  null
  
)

export default component.exports